// extracted by mini-css-extract-plugin
export var orderName = "OrderName-module--order-name--3asPf";